import React from "react";
import { bool, object, oneOf, string } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Forwarded DOM element ref. */
  elemRef: object,
  /** Button with same width as height. */
  equal: bool,
  /** Link with href attribute rendered as button. */
  href: string,
  /** Possible positions of icon inside button. */
  iconPosition: oneOf(["left", "right"]),
  /** Active state. */
  isActive: bool,
  /** Disabled state */
  isDisabled: bool,
  /** Button can take one of possible shapes. */
  shape: oneOf(["radius", "round"]),
  /** Button sizes */
  size: oneOf(["small", "large"]),
  /** Button(input) with `type="submit"`. */
  submit: bool,
  /** Html tag in which is button rendered. */
  tag: string,
  /** Visual type of button. */
  type: oneOf(["primary", "secondary", "link", "hollow"]),
};

const CLASS_ROOT = "btn";

const Button = ({
  className,
  children,
  equal,
  href,
  iconPosition,
  isActive,
  isDisabled,
  size,
  shape,
  submit,
  tag = "button",
  type,
  elemRef,
  ...other
}) => {
  let Tag = tag;
  let buttonType = submit ? "submit" : "button";
  let buttonIsDisabled = isDisabled;
  const buttonIconPosition = iconPosition || null;

  if (href) {
    Tag = "a";
    buttonType = null;
  }

  if (Tag === "a") {
    buttonType = null;
  }

  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--equal`]: equal,
      [`${CLASS_ROOT}--${size}`]: size,
      [`${CLASS_ROOT}--${shape}`]: shape,
      [`${CLASS_ROOT}--${type}`]: type,
      [`${CLASS_ROOT}--icon-${buttonIconPosition}`]: buttonIconPosition,
      "is-active": isActive,
      "is-disabled": Tag === "a" && isDisabled,
    },
    className
  );

  if (isDisabled && Tag === "a") {
    buttonIsDisabled = null;
  }

  const props = {
    disabled: buttonIsDisabled,
    href,
    type: !href ? buttonType : null,
    className: classes,
    ref: elemRef,
    ...other,
  };

  return <Tag {...props}>{children}</Tag>;
};

Button.displayName = "Button";
Button.propTypes = propTypes;

export default Button;
